import { render } from "./SearchWrapper.vue?vue&type=template&id=ffbaabfa&scoped=true"
const script = {}

import "./SearchWrapper.vue?vue&type=style&index=0&id=ffbaabfa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbaabfa"]])

export default __exports__